import { useEffect, useState } from "react";
import { RefreshCw, WifiOff, Clock } from "lucide-react";

// Shows when scores were last fetched and warns when cached data may be outdated.
export function CacheBadge({ savedAt, error, loading, staleAfter, onRefresh }) {
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick((x) => x + 1), 30000); return () => clearInterval(id); }, []);
  if (!savedAt && !error) return null;
  const age = Date.now() - savedAt;
  const stale = error || age > staleAfter;
  const at = savedAt ? new Date(savedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "";
  return (
    <div data-testid="cache-badge" data-stale={stale ? "true" : "false"}
      className={`flex items-center gap-2 text-xs rounded-lg px-3 py-2 ${stale ? "bg-amber-500/10 text-amber-300 border border-amber-500/30" : "text-slate-500"}`}>
      {stale ? (error ? <WifiOff className="w-3.5 h-3.5 shrink-0" /> : <Clock className="w-3.5 h-3.5 shrink-0" />) : <Clock className="w-3.5 h-3.5 shrink-0" />}
      <span className="flex-1" data-testid="cache-badge-text">
        {stale ? `Showing saved scores${at ? ` from ${at}` : ""} — they may be outdated.${error ? " Can't reach the server right now." : ""}` : `Updated ${at}`}
      </span>
      <button onClick={onRefresh} disabled={loading} data-testid="cache-refresh-btn" className="inline-flex items-center gap-1 font-semibold hover:text-white disabled:opacity-50">
        <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} /> Refresh
      </button>
    </div>
  );
}
